module.exports = __webpack_public_path__ + "static/alert-64f1dd44171c8c293b565799d622a21f.png";